import { Layout } from './Layout';
import References from './referenceArchitectures/References';
import HomeTab from './HomeTab';
import TechnologyChoice from './technologyChoice/TechnologyChoice';

export const ArchitectureCenterPage = () => {
  return (
    <Layout>
      <Layout.Route path="" title="Home">
        <HomeTab />
      </Layout.Route>
      <Layout.Route path="technology-choice" title="Technology Choice">
        <TechnologyChoice />
      </Layout.Route>
      <Layout.Route path="references" title="References Architectures">
        <References />
      </Layout.Route>
    </Layout>
  );
};
